export enum EmailSendStatus {
  PENDING = 'Pending',
  CANCELLED = 'Cancelled',
  FAILURE = 'Failure',
  SUCCESS = 'Success'
}
